import styled from "styled-components";

export const StyledError = styled.div`
    text-align: left;
    color: ${(props) => props.theme.colors.red};
    font-size: 12px;
    margin-top: 7px;
`;
